import { render, staticRenderFns } from "./my-collect.vue?vue&type=template&id=1798e1a2&scoped=true"
import script from "./my-collect.vue?vue&type=script&lang=js"
export * from "./my-collect.vue?vue&type=script&lang=js"
import style0 from "./my-collect.vue?vue&type=style&index=0&id=1798e1a2&prod&lang=scss"
import style1 from "./my-collect.vue?vue&type=style&index=1&id=1798e1a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0__ejs@2._efqjtiugzhgbjdza5v3l2szjuq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1798e1a2",
  null
  
)

export default component.exports